module.exports = __webpack_public_path__ + "img/banner04_mo.0518f4ea.png";